<template>

  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on }">

        <v-btn icon v-on="on">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-toolbar color="#0000001f">
          <v-toolbar-title>
            <v-icon left>mdi-file-check mdi-24px</v-icon>
            Sair do modo de edição
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn small icon @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
        <span
          class="text-xs-center"
        >Nenhuma alteração realizada foi salva. O que deseja fazer?</span>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn
            flat
            @click="$router.push(`/pastas/${routeParams.folderId}/show`)"
          >
            Sair sem salvar
          </v-btn>

          <v-btn
            color="#4185f4"
            @click="openSaveModal()"
            dark
          >
            Salvar
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

  export default {
    name: 'BackButtonToFolder',
    data() {
      return {
        dialog: false,
      };
    },
    methods: {
      openSaveModal() {
        this.dialog = false;
        this.$emit('openSaveDocumentModal')
      }
    },
    computed: {
      routeParams() {
        return this.$router.currentRoute.params;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/document/editor/BackButtonToFolder.vue